// extracted by mini-css-extract-plugin
export var post = "Post-module--post--BGomm";
export var postButton = "Post-module--postButton--XsLSH";
export var innerButton = "Post-module--innerButton--V-D7x";
export var iconContainer = "Post-module--iconContainer--MmfHW";
export var postWrapper = "Post-module--postWrapper--XBZBl";
export var postCategory = "Post-module--postCategory--LPPQn";
export var postDate = "Post-module--postDate--6M3qA";
export var postSummary = "Post-module--postSummary--nMqKi";